import { gcj02towgs84 } from '@shared/utils';
export const useMarkers = defineStore('markers', {
  state: () => {
    return {
      markerList: [],
      markerManage: []
    };
  },
  getters: {
    getMarkers: (state) => {
      return state.markerList;
    }
  },
  actions: {
    setMarkers(list) {
      this.markerList = [];
      const markerDir = {
        scenic_spot: this.markerManage['景点'],
        hotel: this.markerManage['酒店'],
        restaurant: this.markerManage['餐饮'],
        parking: this.markerManage['停车场'],
        facility: this.markerManage['设施']
      };
      this.markerList = list.map((item) => {
        const mitem = markerDir[item.apiTypeName].find(
          (val) => val.id == item.id
        );
        let { lng, lat } = gcj02towgs84({
          lng: item.map_lng,
          lat: item.map_lat
        });
        if (
          item.apiTypeName == 'parking' &&
          item.parking_lot - item.current_lot
        ) {
          item.name = `${item.parking_name}(${item.parking_lot - item.current_lot}/${item.parking_lot})`;
        }
        return {
          ...item,
          id: item.id,
          show: true,
          zoom: 15.5,
          lng: Number(lng.toFixed(6)),
          lat: Number(lat.toFixed(6)),
          category: mitem?.loc || 'right',
          markerType: 'def'
        };
      });
    },
    setMarkerManage(list) {
      this.markerManage = list;
    },
    setMarkerVideoList(list) {
      this.markerList = [];
      this.markerList = list.map((item) => {
        // let { lng, lat } = gcj02towgs84({
        //   lng: item.lng,
        //   lat: item.lat
        // });
        return {
          ...item,
          // lng,
          // lat,
          code: item.code,
          show: item.isShow,
          markerType: 'video'
        };
      });
    }
  }
});
